import component from "containers/StaticPages/pages/Sellers";

export default {
  key: "consultant-join",
  title: "Join",
  path: "/:user?/join/:slug?",
  pageName: "join",
  linkTarget: "/join",
  component,
};
